import React, { createContext, useContext, useState, useCallback } from "react";

const BreadcrumbsContext = createContext(null);
export const BreadcrumbsProvider = ({ children }) => {
  const [crumbs, setCrumbs] = useState([]);

  const registerCrumb = useCallback((id, crumb) => {
    setCrumbs((prev) => {
      const index = prev.findIndex((c) => c.id === id);
      if (index !== -1) {
        const updated = [...prev];
        const merged = { ...updated[index], ...crumb };
        if (JSON.stringify(updated[index]) === JSON.stringify(merged)) {
          return prev;
        }
        updated[index] = merged;
        return updated;
      }
      return [...prev, { id, ...crumb }];
    });
  }, []);

  const unregisterCrumb = useCallback((id) => {
    setCrumbs((prev) => {
      const index = prev.findIndex((c) => c.id === id);
      if (index === -1) return prev;
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  }, []);

  const contextValue = React.useMemo(
    () => ({ crumbs, registerCrumb, unregisterCrumb }),
    [crumbs, registerCrumb, unregisterCrumb]
  );
  return (
    <BreadcrumbsContext.Provider value={contextValue}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export const useBreadcrumbsContext = () => {
  const context = useContext(BreadcrumbsContext);

  if (!context) {
    throw new Error(
      "useBreadcrumbsContext must be used within BreadcrumbsProvider"
    );
  }

  return context;
};

export default BreadcrumbsContext;
